function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import cs from 'classnames';
import './SimpleGroupTemplate.css';
import Fieldset from '../../Inputs/Fieldset/Fieldset';
import SemanticSection from '../../SemanticSection/SemanticSection';
import getDisplayName from '../../getDisplayName';
import GroupGridGroupsProvider, { GroupGridGroupsContext } from './GroupGridGroupsContext';
import GroupContext from './GroupContext';
import SizeByOptionsContext from '../Widgets/SizeByOptionsContext';
import { useLabelIcons } from '../Widgets/utils/getLabelIcons';
import getLabelId from '../../Inputs/getLabelId';
import ThemeContext from '../../ThemeContext/ThemeContext';
import WidgetSizeContext from '../WidgetSizeContext';
import useIndentFields from '../IndentFieldsContext/useIndentFields';
import IndentFieldsContext from '../IndentFieldsContext/IndentFieldsContext';
export function GroupContentTemplate(props) {
  return /*#__PURE__*/React.createElement(SemanticSection, null, props.gridGroups.map(function (group) {
    return /*#__PURE__*/React.createElement(Group, {
      group: group,
      isCompact: props.isCompact,
      hasTheme: false
    });
  }));
}

// @ts-ignore
function Group(_ref) {
  var group = _ref.group,
    isCompact = _ref.isCompact,
    hasTheme = _ref.hasTheme;
  var theme = useContext(ThemeContext);
  var _useIndentFields = useIndentFields(),
    indentClassName = _useIndentFields.indentClassName,
    currentContext = _useIndentFields.currentContext,
    disabledContext = _useIndentFields.disabledContext;
  return /*#__PURE__*/React.createElement("div", {
    className: cs('_dm-form-group__children', _defineProperty(_defineProperty({
      '_dm-form-group__children--grid': group.useGrid,
      '_dm-form-group__children--compact': isCompact
    }, indentClassName, indentClassName && group.useGrid), "_dm-form-group__children--".concat(theme), hasTheme))
  }, /*#__PURE__*/React.createElement(IndentFieldsContext.Provider, {
    value: group.useGrid ? disabledContext : currentContext
  }, /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: group.useGrid
  }, group.children)));
}
function BaseSimpleGroupTitleField(props) {
  var TitleField = props.TitleField,
    uiSchema = props.uiSchema,
    idSchema = props.idSchema,
    formContext = props.formContext,
    labelId = props.labelId,
    groupUiIcons = props.groupUiIcons,
    isCompact = props.isCompact,
    gridGroups = props.gridGroups;
  var _useIndentFields2 = useIndentFields(),
    childContext = _useIndentFields2.childContext;
  var isCardView = props.formContext.isCardView;
  return /*#__PURE__*/React.createElement(TitleField, {
    id: labelId,
    idSchema: idSchema,
    title: props.text || '',
    escape: props.escape,
    formContext: formContext,
    help: uiSchema ? uiSchema['ui:help'] : '',
    groupUiIcons: groupUiIcons,
    isGroup: true
  }, isCardView ? /*#__PURE__*/React.createElement(IndentFieldsContext.Provider, {
    value: {
      enabled: false,
      level: 1
    }
  }, /*#__PURE__*/React.createElement(SemanticSection, null, gridGroups.map(function (group) {
    return /*#__PURE__*/React.createElement(Group, {
      group: group,
      isCompact: isCompact,
      hasTheme: true
    });
  }))) : /*#__PURE__*/React.createElement(IndentFieldsContext.Provider, {
    value: childContext
  }, /*#__PURE__*/React.createElement(SemanticSection, null, gridGroups.map(function (group) {
    return /*#__PURE__*/React.createElement(Group, {
      group: group,
      isCompact: isCompact,
      hasTheme: true
    });
  }))));
}
function wrapGroupTitleWidget(WrappedComponent) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component) {
    _inherits(_Class, _React$Component);
    function _Class() {
      _classCallCheck(this, _Class);
      return _possibleConstructorReturn(this, _getPrototypeOf(_Class).apply(this, arguments));
    }
    _createClass(_Class, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React.createElement(GroupGridGroupsContext.Consumer, null, function (gridGroups) {
          return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
            gridGroups: gridGroups
          }, _this.props));
        });
      }
    }]);
    return _Class;
  }(React.Component), _Class.displayName = "WrapAccordionGroupTitleWidget(".concat(getDisplayName(WrappedComponent), ")"), _Class;
}
export var SimpleGroupTitleField = wrapGroupTitleWidget(BaseSimpleGroupTitleField);
function BaseGroupTemplate(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ["children"]);
  var isCardView = props.formContext.isCardView;
  return /*#__PURE__*/React.createElement(GroupGridGroupsProvider, {
    groupChildren: props.children,
    isCardView: isCardView
  }, /*#__PURE__*/React.createElement(SimpleGroupTitleField, Object.assign({
    groupChildren: children
  }, rest)));
}
export function wrapGroupTemplate(WrappedComponent) {
  return function (props) {
    var uiSchema = props.uiSchema,
      formContext = props.formContext;
    var uiOptions = props['ui:options'];
    var theme = useContext(ThemeContext);
    var size = useContext(WidgetSizeContext);
    var id = props.id || '';
    var labelId = getLabelId(id);
    var isCompact = !!(uiOptions && uiOptions.compact === true);
    var autoClass = "auto-group--".concat(id.indexOf('_') === 0 ? id.substring(1) : id);
    var _useLabelIcons = useLabelIcons(labelId, formContext, uiSchema),
      labelledBy = _useLabelIcons.labelledBy,
      labelIcons = _useLabelIcons.labelIcons;
    return /*#__PURE__*/React.createElement(Fieldset, {
      id: "container-".concat(id),
      labelledby: labelledBy,
      className: cs('auto-group', "_dm-form-group--".concat(theme), "_dm-form-group--".concat(theme, "--").concat(size), _defineProperty(_defineProperty({}, autoClass, id.length), '_dm-form-group--compact', isCompact))
    }, /*#__PURE__*/React.createElement(SizeByOptionsContext.Provider, {
      value: isCompact
    }, /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      labelId: labelId,
      groupUiIcons: labelIcons,
      isCompact: isCompact
    }, props))));
  };
}
export default wrapGroupTemplate(BaseGroupTemplate);